import JsonApi from "devour-client";
import UrlHelper from "src/util/urlHelper";
import AppendVueRouteToRequest from "./middlewares/appendVueRouteToRequest";
import SetAuthorizationHeader from "./middlewares/setAuthorizationHeader";
import SetCancelToken from "./middlewares/setCancelToken";
import ErrorHandler from "./middlewares/errorHandler";

const client = new JsonApi({
  apiUrl: UrlHelper.url("api"),
  pluralize: false
});

client.insertMiddlewareBefore("axios-request", AppendVueRouteToRequest);
client.insertMiddlewareBefore("axios-request", SetAuthorizationHeader);
client.insertMiddlewareBefore("axios-request", SetCancelToken);

client.replaceMiddleware('errors', ErrorHandler)
// client.replaceMiddleware("errors", ErrorHandler);

export default client;
